import { useEffect, useState } from "react";

const BASE_WIDTH = 360;
const BASE_HEIGHT = 740;

export const useViewport = () => {
  const [size, setSize] = useState<{ w: number; h: number }>({
    w:
      typeof window !== "undefined"
        ? Math.min(window.innerWidth, BASE_WIDTH)
        : BASE_WIDTH,
    h: typeof window !== "undefined" ? window.innerHeight : BASE_HEIGHT,
  });

  useEffect(() => {
    const onResize = () => {
      setSize({
        w: Math.min(window.innerWidth, BASE_WIDTH),
        h: window.innerHeight,
      });
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const scale = size.w / BASE_WIDTH;
  const px = (n: number) => Math.round(n * scale);

  return { ...size, px, scale };
};
